import { colors } from '@10d/tend-ui-tokens/global';
import { themeFactory } from './utils.js';

const GlobalTheme = themeFactory(colors, {
    Button: {
        dangerDefaultBg: colors.red600,
        dangerGhostDefaultBg: colors.red100,
        dangerGhostDefaultText: colors.red600,
        dangerGhostHoverBg: colors.red50,
        dangerGhostHoverText: colors.red500,
        dangerGhostPressedBg: colors.red300,
        dangerGhostPressedText: colors.red700,
        dangerHoverBg: colors.red500,
        dangerPressedBg: colors.red700,
        dangerSecondaryDefaultBg: colors.red100,
        dangerSecondaryDefaultText: colors.red600,
        dangerSecondaryHoverBg: colors.red50,
        dangerSecondaryHoverText: colors.red500,
        dangerSecondaryPressedBg: colors.red200,
        dangerSecondaryPressedText: colors.red700,
        dangerText: colors.gray0,
        disabledBg: colors.gray50,
        disabledBorder: colors.gray200,
        disabledIcon: colors.gray400,
        disabledText: colors.gray400,
        ghostDefaultText: colors.gray900,
        ghostHoverBg: colors.blue50,
        ghostHoverText: colors.blue500,
        ghostPressedBg: colors.blue200,
        ghostPressedText: colors.blue700,
        primaryDefaultBg: colors.blue600,
        primaryHoverBg: colors.blue500,
        primaryPressedBg: colors.blue700,
        primaryText: colors.gray0,
        secondaryDefaultBg: colors.blue100,
        secondaryDefaultText: colors.blue600,
        secondaryHoverBg: colors.blue50,
        secondaryHoverText: colors.blue500,
        secondaryPressedBg: colors.blue200,
        secondaryPressedText: colors.blue700,
    },
});

export { GlobalTheme };
//# sourceMappingURL=GlobalTheme.js.map
